import React, { PropsWithChildren } from 'react'
import { concatStyles } from 'utils'

const TOGGLE_BUTTON_STYLES =
  'cursor-pointer flex h-full items-center justify-center flex-grow-0 flex-shrink-0 outline-none focus:outline-none w-16 text-secondary hover:bg-white/80 transition-colors'
const TOGGLE_BUTTON_CHILD_WRAPPER_STYLES = 'px-3 md:px-4 block'

export const Toggle: React.FC<PropsWithChildren<{
  active?: boolean
  onClick?: React.MouseEventHandler<any> | any
}>> = ({ active, children, onClick }) => (
  <button
    className={concatStyles([
      TOGGLE_BUTTON_STYLES,
      active ? 'bg-white' : 'bg-transparent',
    ])}
    onClick={onClick}
  >
    <div className={TOGGLE_BUTTON_CHILD_WRAPPER_STYLES}>{children}</div>
  </button>
)

Toggle.displayName = 'Toggle'
